
import { createContext, useContext } from 'react';
import type { UserPermission, InvoiceSettings, ToastType } from '../types';

export interface AuthContextType {
    user: UserPermission | null;
    login: (user: UserPermission, rememberMe: boolean) => void;
    logout: () => void;
    updateUser: (updatedUser: UserPermission, oldEmail: string) => Promise<void>;
    handleDeleteUsers: (usernames: string[]) => void;
}
export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export interface NotificationContextType { 
    showToast: (message: string, type: ToastType, duration?: number) => void; 
}
export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export interface SettingsContextType { 
    invoiceSettings: InvoiceSettings; 
    setInvoiceSettings: (settings: InvoiceSettings) => Promise<void>; 
}
export const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export interface DataRefreshContextType { 
    refreshData: (force?: boolean) => void; 
}
export const DataRefreshContext = createContext<DataRefreshContextType | undefined>(undefined);

export const useAuth = () => { 
    const context = useContext(AuthContext); 
    if (!context) throw new Error('useAuth error'); 
    return context; 
};

export const useNotification = () => { 
    const context = useContext(NotificationContext); 
    if (!context) throw new Error('useNotification error'); 
    return context; 
};

export const useSettings = () => { 
    const context = useContext(SettingsContext); 
    if (!context) throw new Error('useSettings error'); 
    return context; 
};

export const useDataRefresh = () => { 
    const context = useContext(DataRefreshContext); 
    if (!context) throw new Error('useDataRefresh error'); 
    return context; 
};
